import { connect } from 'react-redux';
import { HotelSearchResults } from '@lt/components';
import { getIsWhitelabel, getIsHotelOnly } from 'src/store/view/selectors';
import { openAboutRoomPopup } from 'src/store/roomPopup/slice';
import {
  getCashbackLabel,
  getCashbackLabelBackgroundColor,
  getCashbackLabelTextColor,
  getCashbackTooltip,
  getActivateCashbackForPartner,
  getCashbackIconWebp,
  getCashbackIconPng,
} from 'src/store/cashback/selectors';
import {
  getSearchResultsNights,
  getOffersForCurrentDateWithMealsFilters,
  getIsSetDefaultFilters,
} from '../../store/selectors/searcher';
import { openOfferAction } from '../../store/actions/offer';
import withMobile from '../../hocs/withMobile';
import { getVisibleNightsColumnsCount } from '../../store/selectors/view';

import { openFiltersListAction } from '../../store/actions/searcher';
import { getSearchedNights } from '../../store/selectors/common';
import {
  getHotelFacilitiesRoomForSearcher,
  getHotelRoulette,
} from '../../store/hotel';

const mapStateToProps = (state) => ({
  items: getOffersForCurrentDateWithMealsFilters(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  searchedNights: getSearchedNights(state),
  nights: getSearchResultsNights(state),
  visibleColumns: getVisibleNightsColumnsCount(state),
  hotelFacilities: getHotelFacilitiesRoomForSearcher(state),
  isRoulette: getHotelRoulette(state),
  isWhiteLabel: getIsWhitelabel(state),
  isHotelOnly: getIsHotelOnly(state),
  isSetDefaultFilters: getIsSetDefaultFilters(state),
  labelColor: getCashbackLabelBackgroundColor(state),
  textColor: getCashbackLabelTextColor(state),
  cashbackTooltipText: getCashbackTooltip(state),
  cashbackLabel: getCashbackLabel(state),
  cashbackIconWebp: getCashbackIconWebp(state),
  cashbackIconPng: getCashbackIconPng(state),
});

const mapDispatchToProps = (dispatch) => ({
  onOfferClicked: (offer) => dispatch(openOfferAction(offer)),
  onClickOpenFilters: () => dispatch(openFiltersListAction(true)),
  onLeaveNotFullOffersSpan: () => dispatch(openFiltersListAction(false)),
  onClickGallery: (id) => dispatch(openAboutRoomPopup(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(HotelSearchResults));
